// class SliderComponent extends HTMLElement {
//   constructor() {
//     super();
//     this.slider = this.querySelector('[id^="Slider-"]');
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.currentPageElement = this.querySelector('.slider-counter--current');
//     this.pageTotalElement = this.querySelector('.slider-counter--total');
//     this.prevButton = this.querySelector('button[name="previous"]');
//     this.nextButton = this.querySelector('button[name="next"]');

//     if (!this.slider || !this.nextButton) return;

//     this.initPages();

//     this.nextButton.addEventListener('click', this.onNext.bind(this));
//   }

//   initPages() {
//     this.sliderItemsToShow = Array.from(this.sliderItems).filter((el) => el.clientWidth > 0);
//     if (this.sliderItemsToShow.length < 2) return;
//     this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
//     this.totalPages = this.sliderItemsToShow.length;
//     this.currentPage = 0;
//     this.updateCounter();
//   }

//   updateCounter() {
//     if (this.currentPageElement) this.currentPageElement.textContent = this.currentPage + 1;
//     if (this.pageTotalElement) this.pageTotalElement.textContent = this.totalPages;
//   }

//   onNext() {
//     this.currentPage++;
//     if (this.currentPage >= this.totalPages) {
//       // last slide → jump to first instantly
//       this.currentPage = 0;
//       this.setSlidePosition(this.currentPage * this.sliderItemOffset, false);
//     } else {
//       this.setSlidePosition(this.currentPage * this.sliderItemOffset, true);
//     }
//     this.updateCounter();
//   }

//   setSlidePosition(position, smooth = true) {
//     this.slider.scrollTo({
//       left: position,
//       behavior: smooth ? 'smooth' : 'auto',
//     });
//   }
// }

// customElements.define('slider-component', SliderComponent);




if (window.matchMedia("(max-width: 767px)").matches) {

    $('.ctm-product .product__media-list').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      dots:false,
    centerMode: true,
    centerPadding: '60px',
    });
}



$(document).ready(function(){
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      speed:100,
      prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0551/8334/3786/files/right.png?v=1759236709'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0551/8334/3786/files/right.png?v=1759236709'>",
      fade: false,
      asNavFor: '.slider-nav',
      responsive: [
        {
          breakpoint: 768, // Only apply below 768px screen width
          settings: {
            centerMode: true,
            arrows:false,
            centerPadding: '10px' // You can adjust as needed
          }
        },
        {
          breakpoint: 10000, // Default (desktop and above)
          settings: {
            centerMode: false,
            centerPadding: '0px'
          }
        }
      ]
    });

    $('.slider-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite:true,
      asNavFor: '.slider-for',
      dots: false,
      centerMode: false,
       arrows:false,
      focusOnSelect: true,
       vertical: true,
      swipe: false,             // disable drag/swipe
    touchMove: false,         // disable touch drag
    draggable: false,
      responsive: [
        {
          breakpoint: 768, // Only apply below 768px screen width
          settings: {
             vertical:false,
            swipe: true, 
            slidesToShow:4,          
            touchMove:true,         
          }
        },
      ]   
    });
  });


$(document).ready(function() {
  // Collect all lightbox images
  const $images = $('.lightbox-trigger');
  let currentIndex = 0;

  // Create overlay and controls
  const $overlay = $('<div class="lightbox-overlay"></div>');
  const $content = $('<div class="lightbox-content"></div>');
  const $img = $('<img>');
  const $close = $('<div class="lightbox-close">&times;</div>');
  const $prev = $('<div class="lightbox-prev">&#10094;</div>'); // ‹
  const $next = $('<div class="lightbox-next">&#10095;</div>'); // ›

  $content.append($img);
  $overlay.append($content, $close, $prev, $next);
  $('body').append($overlay);

  function showImage(index) {
    if(index < 0) index = $images.length - 1;
    if(index >= $images.length) index = 0;
    currentIndex = index;
    const src = $images.eq(index).data('large');
    $img.attr('src', src);
    $overlay.addClass('active');
  }

  // Open lightbox on image click
  $images.on('click', function() {
    const idx = $images.index(this);
    showImage(idx);
  });

  // Close lightbox
  $close.on('click', function() {
    $overlay.removeClass('active');
  });

  $overlay.on('click', function(e) {
    if(e.target === this) {
      $overlay.removeClass('active');
    }
  });

  // Next / Prev buttons
  $next.on('click', function(e) {
    e.stopPropagation();
    showImage(currentIndex + 1);
  });

  $prev.on('click', function(e) {
    e.stopPropagation();
    showImage(currentIndex - 1);
  });

  // Keyboard support
  $(document).on('keydown', function(e) {
    if(!$overlay.hasClass('active')) return;

    if(e.key === 'Escape') {
      $overlay.removeClass('active');
    } else if(e.key === 'ArrowRight') {
      showImage(currentIndex + 1);
    } else if(e.key === 'ArrowLeft') {
      showImage(currentIndex - 1);
    }
  });
});


// product page swatch 


// $(document).on("click", ".swatch-input__label", function () {
//   // is label ke andar .ctm_var_img ka data-varimg uthana
//   var imgSrc = $(this).find(".ctm_var_img").attr("data-varimg");

//   // agar imgSrc Shopify ka resized image hai to usse master size me convert karo
//   var originalImg = imgSrc.replace(
//     /_(\d+x\d+|x\d+|crop_center|compact|grande|large|medium|small|thumb|1024x1024|2048x2048)\./,
//     "_master."
//   );

//   // slick-current wali image ka src replace karo
//   var $currentImg = $(".slider-for .slick-current img");
//   $currentImg.attr("src", originalImg);

//   // mobile view ke liye smooth scroll
//   if ($(window).width() < 768) {
//     setTimeout(function () {
//       $("html, body").stop().animate(
//         {
//           scrollTop: $currentImg.offset().top - 20 
//         },
//         500
//       );
//     }, 200); 
//   }
// });


// $(document).on("click", ".swatch-input__label", function () {
//   var selectedAlt = $(this).find(".ctm_var_img").attr("data-alt");

//   if (!selectedAlt) {
//     if ($(window).width() < 768) {
//       $("html, body").stop().animate({ scrollTop: 0 }, 500);
//     }
//     return;
//   }

//   var matchedImg = null;

//   // 🔹 Sirf slider-nav ke andar ke images check karo
//   $(".slider-nav img").each(function () {
//     var imgAlt = $(this).attr("alt");
//     if (imgAlt && imgAlt.trim().toLowerCase() === selectedAlt.trim().toLowerCase()) {
//       matchedImg = $(this);
//       return false; // stop loop
//     }
//   });

//   if (matchedImg) {
//     // 🔸 Lightbox ya main image click prevent karne ke liye temporary flag lagate hain
//     matchedImg.addClass("no-lightbox-click");

//     // Trigger only the thumbnail click
//     matchedImg.trigger("click");

//     // Flag hata do thodi der baad (click complete hone ke baad)
//     setTimeout(function () {
//       matchedImg.removeClass("no-lightbox-click");
//     }, 500);
//   }

//   // 🔹 Prevent lightbox event if this class is present
//   $(document).on("click", ".no-lightbox-click", function (e) {
//     e.stopImmediatePropagation();
//     e.preventDefault();
//   });

//   // 🔹 Mobile scroll to top
//   if ($(window).width() < 768) {
//     setTimeout(function () {
//       $("html, body").stop().animate({ scrollTop: 0 }, 500);
//     }, 400);
//   }
// });



// $(document).on("click", ".swatch-input__label", function () {
//   // get the clicked swatch’s data-varimg
//   var selectedVarImg = $(this).find(".ctm_var_img").attr("data-varimg");

//   // find the active image in slick slider (try both class names)
//   var $activeImg = $(".slider-for .slick-current img, .slider-for .slick-active").first();

//   if (selectedVarImg && $activeImg.length) {
//     $activeImg.attr("src", selectedVarImg);
//     console.log("✅ Updated image src to:", selectedVarImg);
//   } else {
//     console.warn("⚠️ No data-varimg or active image found.");
//   }

//   // 🔹 Always scroll to top (for mobile)
//   if ($(window).width() < 768) {
//     setTimeout(function () {
//       $("html, body").stop().animate({ scrollTop: 0 }, 500);
//     }, 400);
//   }
// });




// document.addEventListener('click', function (e) {
//   // pill label click
//   const pillLabel = e.target.closest(
//     '.custom_variant_pick .product-form__input--pill label'
//   );
//   if (!pillLabel) return;

//   // 2 second delay ke liye setTimeout
//   setTimeout(function () {
//     // swatch container ke andar checked input
//     const checkedInput = document.querySelector(
//       '.custom_variant_pick .product-form__input--swatch input:checked'
//     );
//     if (!checkedInput) return;

//     // checked input ka next sibling label
//     const swatchLabel = checkedInput.nextElementSibling;
//     if (!swatchLabel) return;

//     // label ke andar data-varimg (kisi bhi child se)
//     const varImgEl = swatchLabel.querySelector('[data-varimg]');
//     if (!varImgEl) return;

//     const selectedVarImg = varImgEl.getAttribute('data-varimg');

//     // 🔹 Update slick slider image
//     var $activeImg = $(".slider-for .slick-current img, .slider-for .slick-active").first();

//     if (selectedVarImg && $activeImg.length) {
//       $activeImg.attr("src", selectedVarImg);
//       console.log("✅ Updated image src to:", selectedVarImg);
//     } else {
//       console.warn("⚠️ No data-varimg or active image found.");
//     }

//     // 🔹 Always scroll to top (for mobile)
//     if ($(window).width() < 768) {
//       setTimeout(function () {
//         $("html, body").stop().animate({ scrollTop: 0 }, 500);
//       }, 400);
//     }
//   },700); // 2 second delay
// });


// 🔹 Common Function: Mobile par Image Update aur Scroll karne ke liye
function updateMobileImageAndScroll(newSrc) {
  if (window.innerWidth > 768) return;

  // 1. Image src update
  if (newSrc) {
    var $activeImg = $('img.slick-current');
    $activeImg.attr('src', newSrc);
    $activeImg.attr('data-src', newSrc);
    $activeImg.attr('srcset', newSrc);

    console.log('✅ Updated Active Image src:', newSrc);
  }

  // 2. Focus remove karein taaki browser auto-scroll issue na kare
  if (document.activeElement) {
    document.activeElement.blur();
  }

  // 3. Mobile smooth scroll to top
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// -------------------------------------------------------------
// 🟢 1. Swatches / Pills (Click Event)
// -------------------------------------------------------------
$(document).on('click', '.swatch-input__label, .product-form__input--pill label', function (e) {
  if (window.innerWidth > 768) return;

  e.preventDefault();
  e.stopPropagation();

  var $this = $(this);
  var inputId = $this.attr('for');
  var $input = inputId ? $('#' + $.escapeSelector(inputId)) : $this.siblings('input, [type="radio"]');

  // Radio Input ko manually select karein
  if ($input.length) {
    $input.prop('checked', true);
  }

  // Selected Value/Title Update
  var selectedValue = $this.attr('title') || ($input.length ? $input.val() : '');
  if (selectedValue) {
    $this.closest('fieldset').find('[data-selected-value]').text(selectedValue.trim());
  }

  // Image Source Fetching
  var newSrc = $this.find('.ctm_var_img').attr('data-varimg');
  if (!newSrc && $input.length) {
    newSrc = $input.attr('data-variant-image');
  }

  // Image Update & Scroll Trigger
  updateMobileImageAndScroll(newSrc);
});

// -------------------------------------------------------------
// 🟢 2. Select Box Dropdown (Change Event)
// -------------------------------------------------------------
$(document).on('change', 'select.select__select, .product-form__input select', function () {
  if (window.innerWidth > 768) return;

  // Selected option se data-variant-image fetch karna
  var $selectedOption = $(this).find('option:selected');
  var newSrc = $selectedOption.attr('data-variant-image');

  // Image Update & Scroll Trigger
  updateMobileImageAndScroll(newSrc);
});









  // document.addEventListener("DOMContentLoaded", function() {
  //   Fancybox.bind("[data-fancybox='gallery']", {
  //     Thumbs: true,     
  //     Toolbar: {
  //       display: ["close"],
  //     },
  //     animated: true,
  //     dragToClose: true,
  //   });
  // });





  // document.addEventListener("DOMContentLoaded", function() {
  //   var lightbox = new SimpleLightbox('.slider-for a', {
  //     captions: true,
  //     captionSelector: 'self',
  //     captionType: 'attr',
  //     captionsData: 'data-title',
  //     captionPosition: 'bottom',
  //     captionDelay: 250
  //   });
  // });






